import { memo } from 'react';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid,
    Tooltip, ResponsiveContainer,
} from 'recharts';
import { BiGridVertical } from 'react-icons/bi';
import { currencySymbol } from '../../constants/currencies';

const TOOLTIP_STYLE = {
    backgroundColor: 'var(--bs-body-bg)',
    border: '1px solid var(--bs-border-color)',
    borderRadius: '0.5rem',
    color: 'var(--bs-body-color)',
};

// `currency` is the company base currency (figures are server-converted into it).
export default memo(function ProfitChart({ data, currency = 'GBP' }) {
    if (!data?.length) return null;

    const sym = currencySymbol(currency);
    const fmt = (v) => `${sym}${v.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    const tickFmt = (v) => v === 0 ? `${sym}0` : `${sym}${Math.abs(v) >= 1000 ? `${(v / 1000).toFixed(0)}k` : v}`;

    return (
        <div className="surface h-100 recharts-outline-none d-flex flex-column">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h3 className="fw-semibold fs-5 mb-0 drag-handle">Profit over Time</h3>
                <BiGridVertical className="drag-handle text-muted flex-shrink-0 d-none d-md-block" style={{ opacity: 0.4, fontSize: '1.1rem' }} />
            </div>
            <div className="flex-grow-1" style={{ minHeight: 0 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={data} margin={{ top: 8, right: 16, bottom: 4, left: 8 }}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--bs-border-color)" />
                        <XAxis
                            dataKey="monthLabel"
                            stroke="var(--bs-body-color)"
                            tick={{ fontSize: 11, fill: 'var(--bs-secondary-color)' }}
                            tickLine={false}
                        />
                        <YAxis
                            tickFormatter={tickFmt}
                            stroke="var(--bs-body-color)"
                            tick={{ fontSize: 11, fill: 'var(--bs-secondary-color)' }}
                            tickLine={false}
                            axisLine={false}
                            width={55}
                        />
                        <Tooltip
                            formatter={(v) => [fmt(v), 'Profit']}
                            contentStyle={TOOLTIP_STYLE}
                            labelStyle={{ color: 'var(--bs-body-color)', fontWeight: 600 }}
                            itemStyle={{ color: 'var(--bs-body-color)' }}
                        />
                        <Line
                            type="monotone"
                            dataKey="profit"
                            stroke="var(--bs-primary)"
                            strokeWidth={2.5}
                            dot={{ r: 4, fill: 'var(--bs-primary)', strokeWidth: 0 }}
                            activeDot={{ r: 6 }}
                            isAnimationActive={false}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
});
